import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HelpCenterSettingsWidgetConfigurationAppQuery from '@atlassian/jira-relay/src/__generated__/HelpCenterSettingsWidgetConfigurationAppQuery.graphql';

export const HelpCenterSettingsWidgetConfigurationAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-widget-configuration-app" */ './src/ui/HelpCenterSettingsWidgetConfigurationApp.tsx'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				page: {
					parameters: HelpCenterSettingsWidgetConfigurationAppQuery,
					variables: {
						cloudId,
						helpCenterAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
